export default __webpack_public_path__ + "static/media/CivilEng_Shapes-04.9c6eec72.png";